import { createContext } from 'react';

const ownerContext = createContext({ userId: null, isMe: false });

export default ownerContext;
